export const formatCmsTextToHtml = (rawText = "") => {
  return (
    rawText
      // Convert \n to <br />
      .replace(/\\n/g, "<br />")
      // Convert <link>URL</link> to <a>URL</a>
      .replace(/<link>(.*?)<\/link>/g, (match, url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#0066cc">${url}</a>`;
      })
      // Convert <mail>EMAIL</mail> to mailto anchor
      .replace(/<mail>(.*?)<\/mail>/g, (match, email) => {
        return `<a href="mailto:${email}" style="color:#0066cc">${email}</a>`;
      })
      // Convert <chat>TEXT</chat> to clickable span
      .replace(/<chat>(.*?)<\/chat>/g, (match, text) => {
        return `<span style="color:#0066cc; cursor:pointer;" data-click="cms-live-chat">${text}</span>`;
      })
      // Convert <strong> to span with bold styling
      .replace(
        /<strong>(.*?)<\/strong>/g,
        '<span style="font-weight:700">$1</span>'
      )
      // Convert TM to superscript
      .replace(/TM/g, "<sup>TM</sup>")
      // Convert <b>TEXT</b> to span with bold styling
      .replace(/<b>(.*?)<\/b>/g, '<span style="font-weight:700">$1</span>')
      // ✅ Convert <color>#hex|Text</color> to styled span
      .replace(
        /<color>(#[0-9a-fA-F]{3,6})\|(.*?)<\/color>/g,
        (match, color, text) => {
          return `<span style="color:${color}">${text}</span>`;
        }
      )
      .replace(
        /<color>(#[0-9a-fA-F]{3,6})\|(.*?)<\/color>/g,
        (_, color, text) => `<span style="color:${color}">${text}</span>`
      )
  );
};
